<!--
 * @Author: your name
 * @Date: 2020-07-23 09:41:33
 * @LastEditTime: 2020-10-15 18:19:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_wap\src\pages\login\nvc.vue
-->
<template>
  <div id="captcha">
    <remote-js src="//g.alicdn.com/sd/nvc/1.1.112/guide.js"></remote-js>
  </div>
</template>
<script>
export default {
  name: "nvc",
  components: {
    "remote-js": {
      render(createElement) {
        const self = this;
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src },
          on: {
            load() {
              self.$emit("loaded");
            },
          },
        });
      },
      props: {
        src: { type: String, required: true },
      },
    },
  },
  props: {
    type: {},
  },
  data() {
    return {
      cb: function () {},
    };
  },
  methods: {
    // 开始人机验证
    toVerify(cb) {
      setTimeout(() => {
        window.NVC_Opt.scene=this.type //切换场景
          let params = getNVCVal();
        //let params ='' ;
        this.cb = cb;
        this.cb(params);
      }, 200);
    },
    //验证回调
    verifyLater(data) {
      //验证成功
      if (data.code === -100 ||data.code === 100 || !data.data ) {
        let container = document.getElementsByClassName("nc-container")[0];
        if (container) {
          container.style.display = "none";
        }
        nvcReset();
        return false;
      }
      if (data.code == 400) {
        //唤醒滑动验证
        getNC().then(function () {
          NoCaptcha.upLang("cn", {
            LOADING: "加载中...", //加载
            SLIDER_LABEL: "请向右滑动验证", //等待滑动
            CHECK_Y: "验证通过", //通过
            ERROR_TITLE: "非常抱歉，这出错了...", //拦截
            CHECK_N: "验证未通过", //准备唤醒二次验证
            OVERLAY_INFORM: "经检测你当前操作环境存在风险，请输入验证码", //二次验证
            TIPS_TITLE: "验证码错误，请重新输入", //验证码输错时的提示
          });
          _nvc_nc.reset();
        });
      } else if (data.code == 600) {
        //唤醒刮刮卡
        getSC().then(function () {});
      } else if (data.code == 700) {
        //唤醒问答验证码
        getLC();
      } else if (data.code == 100 || data.code == 200) {
        //验证成功
        nvcReset();
      } else if (data.code == 800 || data.code == 900) {
        //直接拦截
        nvcReset();
      }
    },
  },
  created() {
    let _this = this;
    /**人机验证配置**/
    window.NVC_Opt = {
      //无痕配置 && 滑动验证、刮刮卡、问答验证码通用配置
      appkey: "FFFF0N2N000000008320",
      scene: this.type,
      isH5: true,
      popUp: false,
      renderTo: "#captcha",
      nvcCallback: function (data) {
        _this.cb(data)
        // data为getNVCVal()的值，此函数为二次验证滑动或者刮刮卡通过后的回调函数
        // data跟业务请求一起上传，由后端请求AnalyzeNvc接口，接口会返回100或者900
      },
      trans: { key1: "code0", nvcCode: 400 },
      language: "cn",
      //滑动验证长度配置
      customWidth: 300,
      //刮刮卡配置项
      width: 300,
      height: 100,
      elements: [
        "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png",
        "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png",
      ],
      bg_back_prepared:
        "//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png",
      bg_front:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC",
      obj_ok: "//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png",
      bg_back_pass:
        "//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png",
      obj_error: "//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png",
      bg_back_fail:
        "//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png",
      upLang: {
        cn: {
          _ggk_guide: "请在屏幕上滑动，刮出两面盾牌",
          _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
          _ggk_loading: "加载中",
          _ggk_fail: [
            "呀，盾牌不见了<br/>请",
            "javascript:NoCaptcha.reset()",
            "再来一次",
            "或",
            "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
            "反馈问题",
          ],
          _ggk_action_timeout: [
            "我等得太久啦<br/>请",
            "javascript:NoCaptcha.reset()",
            "再来一次",
            "或",
            "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
            "反馈问题",
          ],
          _ggk_net_err: [
            "网络实在不给力<br/>请",
            "javascript:NoCaptcha.reset()",
            "再来一次",
            "或",
            "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
            "反馈问题",
          ],
          _ggk_too_fast: [
            "您刮得太快啦<br/>请",
            "javascript:NoCaptcha.reset()",
            "再来一次",
            "或",
            "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
            "反馈问题",
          ],
        },
      },
    };
  },
};
</script>
<style lang="less" >
#captcha {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  width: 100%;
  height: 0;
  z-index: 999;
  ._nc {
    position: absolute;
    width: 100%;
    height: 469px;
    background-color: rgba(0, 0, 0, 0.8);
    top: -235px;
    box-sizing: border-box;
    .stage1{
      margin-top: 60%;
    }
  }
  .nc-container {
    position: absolute;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    padding-top: 60%;
    width: 100% !important;
    a {
      color: #00c1de;
    }
    .nc-toolbar {
      width: 300px;
      margin: 0 auto;
      .nc-lang-cnt {
        color: #cccccc;
      }
    }
    .nc-canvas {
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/nvc.vue